import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RiskScoreItem } from '../../../types';
import { individualClientsRiskApi } from '../services';

export interface IndiviualClientsActivitiesFormState {
  itemId?: string;
  item?: RiskScoreItem;
}

const initialState: IndiviualClientsActivitiesFormState = {};

export const individualClientsActivitiesFormSlice = createSlice({
  name: 'individualClientsActivitiesForm',
  initialState,
  reducers: {
    clearClientsActivitiesFormState: (state) => {
      state.itemId = undefined;
      state.item = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      individualClientsRiskApi.endpoints.getClientsActivity.matchFulfilled,
      (state, action: PayloadAction<{ data: RiskScoreItem }>) => {
        state.item = action.payload.data;
        state.itemId = action.payload.data.id;
      },
    );
  },
});

export const { clearClientsActivitiesFormState } =
  individualClientsActivitiesFormSlice.actions;

export default individualClientsActivitiesFormSlice.reducer;
